import { I18n } from '@aws-amplify/core';

import type { BeraReportV2SelectedFactor } from '@/types/Bera';

const NOT_AVAILABLE = 'N/A';

export function toFactorText(factor: BeraReportV2SelectedFactor): string {
	if (!factor) {
		const notAvailable = I18n.get(NOT_AVAILABLE);

		return notAvailable;
	}

	const result = I18n.get(factor.description);

	return result;
}

export function toJobElement(jobElement: string): string {
	const result = jobElement || I18n.get(NOT_AVAILABLE);

	return result;
}
